/** @format */

import axios from 'axios';

import { getStoredAuthToken } from '../../Shared/utils/authToken';
import { baseApiUrl } from '../../Shared/utils/helper';

export const submitClubForm = async ({
  method = 'post',
  url,
  values,
  files = [],
  removeImageIds = [],
}) => {
  const formData = new FormData();

  Object.entries(values).forEach(([key, value]) => {
    if (value !== '' && value !== null && value !== undefined) {
      formData.append(key, value);
    }
  });

  files.forEach((file) => {
    formData.append('images[]', file);
  });

  removeImageIds.forEach((id) => {
    formData.append('remove_image_ids[]', id);
  });

  const token = getStoredAuthToken();

  return axios({
    method,
    baseURL: baseApiUrl(),
    url,
    data: formData,
    headers: {
      Accept: 'application/json',
      Authorization: token ? `Bearer ${token}` : undefined,
      'Content-Type': 'multipart/form-data',
    },
  });
};
